<template>
  <div class="empty">
    <div class="empty-image" :style="{ width: imgSize + 'px', height: imgSize + 'px' }"></div>
    <div class="empty-text">{{ text }}</div>
    <slot></slot>
  </div>
</template>

<script>
import i18n from '@/locales/index'
export default {
  props: {
    text: {
      type: String,
      default: `${i18n.t('Common.noData')}`
    },
    imgSize: {
      type: Number,
      default: 128
    }
  }
}
</script>

<style lang="scss" scoped>
.empty {
  width: max-content;
  .empty-image {
    margin: 0 auto;
    background-image: url('../../assets/no_data.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
  .empty-text {
    margin-top: 24px;
    line-height: 22px;
    font-size: 14px;
    font-weight: 400;
    color: #a7a3a1;
    text-align: center;
  }
}
</style>
